import { isInsurancePolicyExpired } from '@/pages/Profile/utils/isInsurancePolicyExpired';
import type { InsurancePolicy } from '@/types/insurancePolicy';

export const isInactivePolicy = (policy: InsurancePolicy) =>
  policy.priority_type === 'Inactive' || isInsurancePolicyExpired(policy.plan_end_date);
